import { render, staticRenderFns } from "./AppNewOrEdit.vue?vue&type=template&id=8ebabf5c&"
import script from "./AppNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./AppNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports